import React, { useState, useEffect } from "react";
import { Box, TextField, Typography, IconButton, Grid } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import VisibilityIcon from "@mui/icons-material/Visibility";
import PasswordChange from "../EditableComponents/PasswordChange";
import PINChange from "../EditableComponents/PINChange";
import TermsAndConditions from "../EditableComponents/TermsAndConditions";
import Support from "../EditableComponents/Support";

function Settings() {
    const [locationData, setLocationData] = useState(null);
    const [open, setOpen] = useState({
        password: false,
        pin: false,
        kycdocs: false,
        support: false,
        terms: false
    })

    useEffect(() => {
        // Fetch location data using an external IP geolocation service
        const fetchLocation = async () => {
          try {
            const response = await fetch("https://ipapi.co/json/");
            if (!response.ok) {
              throw new Error("Failed to fetch location data");
            }
            const data = await response.json();
            setLocationData(data);
          } catch (err) {
            console.error("Error fetching location data:", err);
        }
        };
    
        fetchLocation();
      }, []);

      console.log(locationData?.ip)


  return (
    <Box
      sx={{
        backgroundColor: "#f9f9f9",
        padding: 2,
        borderRadius: 2,
        display: "flex",
        flexDirection: "column",
        gap: 2,
      }}
    >
        <PasswordChange open={open.password} handleCloseModal={() => setOpen({ ...open, password: false })} />
        <PINChange open={open.pin} handleCloseModal={() => setOpen({ ...open, pin: false })} />
        <TermsAndConditions open={open.terms} handleCloseModal={() => setOpen({ ...open, terms: false })} />
        <Support open={open.support} handleCloseModal={() => setOpen({ ...open, support: false })} />
      <Typography variant="h6" sx={{ marginBottom: 2, fontFamily: "Nunito" }}>
        Settings
      </Typography>

      <Box
        sx={{
          p: 3,
          backgroundColor: "white",
          borderRadius: "8px",
          boxShadow: 0.2,
        }}
      >
        <Grid container spacing={2}>
          {[
            { label: "Language", value: "EN", editable: false, disabled: true },
            { label: "Password", value: "******", editable: true, onClick: () => {setOpen({ ...open, password: true })} },
            { label: "KYC Documents", value: "******", editable: false, onClick: () => {setOpen({ ...open, kycdocs: true })} },
            { label: "Support", value: "******", editable: true, onClick: () => {setOpen({ ...open, support: true })} },
            { label: "Privacy PIN", value: "******", editable: true, onClick: () => {setOpen({ ...open, pin: true })} },
            { label: "Terms & Conditions", value: "******", editable: true, onClick: () => {setOpen({ ...open, terms: true })}, readOnly: true },
            { label: "Current Location", value: `${locationData?.ip}`, editable: false, disabled: true },
          ].map(({ label, value, editable = true, readOnly=false, onClick }) => (
            <Grid item xs={12} sm={6} key={label}>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <TextField
                    variant="standard"
                    label={label}
                    value={value || "Loading..."} // Safeguard to handle undefined values
                    disabled={!editable}
                    InputProps={{
                        readOnly: true,
                        sx: { height: "40px", padding: "0 8px" }, // Reducing the input height
                        endAdornment: editable && (
                        <IconButton
                            onClick={onClick}
                        >
                            {readOnly ? <VisibilityIcon /> : <EditIcon />}
                        </IconButton>
                        ),
                    }}
                    InputLabelProps={{
                        sx: { fontSize: "0.875rem", lineHeight: "1.2" }, // Adjusting the label size
                    }}
                    sx={{
                        flex: 1,
                        marginRight: editable ? 1 : 0,
                    }}
                />
              </Box>
            </Grid>
          ))}
        </Grid>
      </Box>
    </Box>
  );
}

export default Settings;
